/** @format */

import { SVGProps } from 'react';

const CloseIcon = (props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) => (
  <svg
    width={12}
    height={12}
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    role='img'
    {...props}
  >
    <path
      d='m1.333 11.25-.583-.583L5.417 6 .75 1.333 1.333.75 6 5.417 10.667.75l.583.583L6.583 6l4.667 4.667-.583.583L6 6.583 1.333 11.25Z'
      fill='#131316'
    />
  </svg>
);

export default CloseIcon;
